import { useSelector } from 'react-redux';
import { getTerminology, getTermOptionsFromDB } from '../utils/termUtils';

/**
 * Custom hook to get terminology and term options
 * @returns {Object} - { terminology, termOptions, terms, schooldetails }
 */
export const useTerminology = () => {
    const schooldetails = useSelector((state) => state.schooldetails || []);
    
    const terminology = getTerminology(schooldetails);
    const termOptions = getTermOptionsFromDB(schooldetails);
    const terms = schooldetails.length > 0 ? (schooldetails[0]?.terms || []) : [];
    
    return {
        terminology,
        termOptions,
        terms,
        schooldetails
    };
};
